<template>
  <div class="h-full risk overflow-y-auto overflow-x-hidden pl-10px">
    <div class="w-full h-25/100 mt-5px">
      <div class="flex justify-start items-start mb-10px mt-10px">
        <img src="../../../assets/images/titleIcon.png" alt />
        <span class="text-16px text-white ml-4px">AI报警分析</span>
      </div>
      <div class="h-[calc(100%-26px)]">
        <v-chart
          v-loading="pieLoading"
          :options="option"
          autoresize
          class="w-full h-full"
        ></v-chart>
      </div>
    </div>
    <div class="mt-10px" v-loading="alarmLoading">
      <div class="flex justify-between h-32px items-center">
        <div class="flex justify-start items-center mb-10px leading-32px h-32px">
          <img src="../../../assets/images/titleIcon.png" alt />
          <div class="text-16px text-white ml-4px">今日实时报警</div>
        </div>
        <div
          class="charge-bg h-32px px-10px text-white cursor-pointer text-14px !leading-32px"
          @click="openAlarmList"
        >
          {{ alarmingCount }}/{{ todayAlarmCount }}今日报警
        </div>
      </div>
      <div class="flex">
        <div class="w-100px h-100px pie-bg">
          <v-chart
            v-loading="chartLoading"
            :options="pieOption"
            autoresize
            class="w-full h-full"
          ></v-chart>
        </div>
        <div class="flex flex-wrap flex-1 justify-between">
          <div
            class="w-110px h-25px relative text-14px pl-5px py-5px alarm-bg"
            v-for="(item, index) in alarmTypeList"
            :key="index"
          >
            <div class="absolute w-2px left-0 top-0">
              <div class="w-full h-8px" :style="`backgroundColor: ${item.color}`"></div>
              <div
                class="w-0px h-0px border-t-2px border-r-2px"
                :style="`borderColor: ${item.color} transparent transparent transparent`"
              ></div>
            </div>
            <div class="flex">
              <div class="text-hex-c0fbfe mr-5px">{{ item.label }}</div>
              <div class="flex">
                <div class="text-white w-30px truncate" :title="item.data">{{ item.data }}</div>
                <div class="text-hex-59bfbc">次</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full h-52/100 overflow-hidden mt-10px">
      <div class="flex justify-start items-start mb-10px mt-10px">
        <img src="../../../assets/images/titleIcon.png" alt />
        <span class="text-16px text-white ml-4px">SIS报警</span>
      </div>
      <div class="w-full h-[calc(100%-90px)]">
        <el-table
          ref="tableRef"
          height="100%"
          class="mt-4px"
          :data="detailList"
          highlight-current-row
          v-loading="warningLoading"
        >
          <el-table-column label="标题" prop="name" show-overflow-tooltip> </el-table-column>
          <el-table-column label="测点" prop="pointCode" show-overflow-tooltip> </el-table-column>
          <el-table-column label="状态" prop="alarmStauts" width="120">
            <template slot-scope="{ row }">
              <span style="color: #F5222D;" v-if="row.alarmStauts">报警中</span>
              <span v-else>已消除</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          small
          background
          :current-page.sync="pageInfo.pageNo"
          :page-size.sync="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          class="text-center"
        ></el-pagination>
      </div>
    </div>
    <person-alarm-list
      v-if="alarmListVisible"
      :alarmListVisible.sync="alarmListVisible"
    ></person-alarm-list>
  </div>
</template>
<script>
import { map, filter, forEach } from 'lodash'
import dayjs from 'dayjs'
import { StandardAlarmRecordApi, StandardAlarmSettingApi } from '@wiz-api/personnel-position'
import { DCSAlarmRecordApi } from '@wiz-api/dcsthreshold-alarm-management'

// 报警列表
const PersonAlarmList = () => {
  return import('../components/PersonAlarmList')
}

const dCSAlarmRecordApi = new DCSAlarmRecordApi()
const alarmRecordApi = new StandardAlarmRecordApi()
const alarmSettingApi = new StandardAlarmSettingApi()
export default {
  data() {
    return {
      detailList: [
        {
          name: '主汽温度',
          pointCode: 'N1DCS.AMMST',
          alarmStauts: false,
        },
        {
          name: '一次再热气温',
          pointCode: 'N1DCS.010LBB11BT601',
          alarmStauts: false,
        },
        {
          name: '炉膛出氧量',
          pointCode: 'N1DCS.010RAA10BQ101',
          alarmStauts: false,
        },
        {
          name: '循环水入口温度',
          pointCode: 'N1DCS.010PAB31BT301',
          alarmStauts: false,
        },
      ],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 4,
      },
      warningLoading: false, // 报警列表是否加载中
      todayAlarmCount: 0, // 今日报警总数
      alarmingCount: 0, // 报警中总数
      alarmListVisible: false, // 报警列表是否可见
      alarmLoading: false,
      chartLoading: false,
      pieLoading: false, // 报警分析图表是否加载中
      option: {
        color: ['#45F2EB', '#3CD495', '#75C7FF', '#FEFF26'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            radius: [0, 60],
            center: ['50%', '50%'],
            data: [
              {
                name: '人数异常',
                value: 1,
              },
              {
                name: '未带安全帽',
                value: 3,
              },
              {
                name: '抽烟',
                value: 4,
              },
              {
                name: '带电话',
                value: 2,
              },
              {
                name: '违规翻越',
                value: 1,
              },
            ],
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: '{b}: {c}',
                textStyle: {
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontSize: 12,
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
          },
        ],
      },
      pieOption: {
        backgroundColor: 'transparent',
        color: [
          '#6e66ac',
          '#e1775a',
          '#f3ad68',
          '#75f9ef',
          '#5bc572',
          '#fbe661',
          '#3a84f7',
          '#fa00ff',
        ],
        title: {
          // eslint-disable-next-line no-useless-concat
          text: `${'{name|' + '报警总数' + '}\n{val|'}${0}}{unit|` + '次' + '}',
          top: 'center',
          left: 'center',
          textStyle: {
            rich: {
              name: {
                fontSize: 12,
                color: 'white',
                padding: [5, 0, 0, 0],
              },
              val: {
                fontSize: 15,
                color: 'white',
                fontWeight: 'bold',
                padding: [-5, 0, 0, 0],
              },
              unit: {
                fontSize: 12,
                color: 'white',
                padding: [-7, 0, 0, 0],
              },
            },
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['58%', '70%'],
            center: ['50%', '50%'],
            data: [
              {
                name: '非法进入',
                value: 5,
              },
              {
                name: '非法离开',
                value: 1,
              },
              {
                name: '超员报警',
                value: 2,
              },
              {
                name: '缺员报警',
                value: 0,
              },
              {
                name: '停留报警',
                value: 2,
              },
              {
                name: '静止报警',
                value: 2,
              },
              {
                name: 'SOS报警',
                value: 0,
              },
              {
                name: '跌落报警',
                value: 0,
              },
            ],
            hoverAnimation: false,
            label: {
              show: false,
            },
          },
        ],
      },
      // 报警类型映射
      alarmTypeList: [
        {
          label: '非法进入',
          value: 'Entry',
          data: 5,
          color: '#6e66ac',
        },
        {
          label: '非法离开',
          value: 'Leave',
          data: 1,
          color: '#e1775a',
        },
        {
          label: '超员报警',
          value: 'Overcrowding',
          data: 2,
          color: '#f3ad68',
        },
        {
          label: '缺员报警',
          value: 'LackOfStaff',
          data: 0,
          color: '#75f9ef',
        },
        {
          label: '停留报警',
          value: 'Remain',
          data: 2,
          color: '#5bc572',
        },
        {
          label: '静止报警',
          value: 'Rest',
          data: 2,
          color: '#fbe661',
        },
        {
          label: 'SOS报警',
          value: 'SOS',
          data: 0,
          color: '#3a84f7',
        },
        {
          label: '跌落报警',
          value: 'Drop',
          data: 0,
          color: '#fa00ff',
        },
      ],
      TypeList: [],
    }
  },
  components: {
    PersonAlarmList,
  },
  async created() {
    // 使用假数据临时展示
    // await this.getList()
    // await this.getAlarmTotal()
    // await this.getAlarmList()
    // await this.getAlarmTypeList()
    // await this.getThreeDimensionalCount()
  },
  methods: {
    async getList() {
      this.warningLoading = true
      const [err, res] = await dCSAlarmRecordApi.getList({
        ...this.form,
        skipCount: (this.pageInfo.pageNum - 1) * this.pageInfo.pageSize,
        maxResultCount: this.pageInfo.pageSize,
      })
      this.warningLoading = false
      if (!err) {
        this.detailList = res.items
        this.pageInfo.total = res.totalCount
      }
    },
    // 获取报警列表
    async getAlarmList() {
      this.alarmLoading = true
      const [err, res] = await alarmRecordApi.getList({
        startTime: dayjs()
          .startOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs()
          .endOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        skipCount: 0,
        maxResultCount: 10000,
      })
      if (!err && res) {
        this.pieOption.series[0].data = map(this.alarmTypeList, (item) => {
          return {
            name: item.label,
            value: filter(res.items, ['alarmType', item.value]).length,
          }
        })
        ;(this.pieOption.title.text =
          `${'{name|' + '报警总数' + '}\n{val|'}${res.totalCount}}{unit|` + '次' + '}'),
          forEach(this.alarmTypeList, (item) => {
            item.data = filter(res.items, ['alarmType', item.value]).length
          })
      }
      this.alarmLoading = false
    },
    // 获取报警总数
    async getAlarmTotal() {
      const [err, res] = await alarmRecordApi.statisticalAlarmTotals()
      if (!err && res) {
        this.alarmingCount = res.toDayNotalarmCount
        this.todayAlarmCount = res.toDayalarmCount
      }
    },
    openAlarmList() {
      this.alarmListVisible = true
    },
    // 获取报警类型
    async getAlarmTypeList() {
      const [err, res] = await alarmSettingApi.getAlarmTypesFromSetting({ type: 0 })
      if (!err && res) {
        Object.keys(res).forEach((key) => {
          this.TypeList.push({
            label: res[key],
            value: key,
          })
        })
      }
    },
    // 获取报警列表数值
    async getWarnListCount(type) {
      const startTime = dayjs()
        .startOf('month')
        .toISOString()
      const endTime = dayjs()
        .endOf('month')
        .toISOString()
      const [err, res] = await alarmRecordApi.getList({
        alarmType: type,
        startTime,
        endTime,
      })
      if (!err && res) {
        return res.totalCount
      }
      return 0
    },
    // 获取饼状图数据
    async getThreeDimensionalCount() {
      this.pieLoading = true
      // 遍历this.alarmTypeList根据value,获取值，根据值和label给this.option.series[0].data赋值
      this.TypeList.forEach(async (item) => {
        const count = await this.getWarnListCount(item.value)
        this.option.series[0].data.push({
          name: item.label,
          value: count,
        })
      })
      this.pieLoading = false
    },
  },
}
</script>
<style lang="scss" scoped></style>
